export const OperatorConstants = {
  STAFFER_PROFILE: 'staff',
  SUPERVISOR_PROFILE: 'supervision',
};

export const ChannelTypeConstants = {
  TYPE_TELEPHONE_HOTLINE: 'voice',
  TYPE_ONLINE_HOTLINE: 'webchat',
  TYPE_ONLINE_TEXT: 'sms',
  TYPE_ONLINE_WHATSAPP: 'whatsapp',
  TYPE_ONLINE_DISCORD: 'discord',
  TYPE_ONLINE_SIGNAL: 'signal',
};

export const TaskConstants = {
  TYPE_SURVIVOR: 'survivor',
  TYPE_INTERNAL: 'internal',
};

export const DateConstants = {
  STANDARD_DATE_FORMAT: 'MM/dd/yyyy hh:mm a',
  STANDARD_TIME_FORMAT: 'hh:mm a',
};

export const AvailableServices = {
  HELPROOMS: 'helprooms',
  HOTLINES: 'hotlines',
  RESOURCES: 'resources',
  WORKSPACES: 'workspaces',
} as const;

export const HotlinesNameSpaces = {
  APPS: 'apps',
  ANNOUNCEMENTS: 'announcements',
  BLOCKED_NUMBERS: 'blocked-numbers',
  DO_NOT_BLOCK_NUMBERS: 'do-not-block-numbers',
  CHANNEL_ONCALLS: 'channel-oncalls',
  CHANNEL_RESOURCE_CATALOGS: 'channel-resource-catalogs',
  CHANNEL_RESOURCES: 'channel-resources',
  CHANNELS: 'channels', // TODO: Duplicate namespace [8]
  CHANNEL_TYPES: 'channel-types', // TODO: Duplicate namespace [1]
  CHANNEL_UI_TABS: 'channel-ui-tabs',
  CONVERSATIONS: 'conversations',
  ENDPOINTS: 'endpoints', // TODO: Duplicate namespace [3]
  INGRESS_CONTROLLER_UI_TABS: 'ingress-controller-ui-tabs',
  INGRESS_FILTERS: 'ingress-filters',
  INGRESS_RESOURCES: 'ingress-resources',
  INTERNAL_CONVERSATIONS: 'internal-conversations',
  LOGS: 'logs',
  MESSAGING_SERVICE_KEYS: 'messaging-service-keys',
  OMNICHANNEL: 'omnichannel',
  OMNICHANNEL_ONCALLS: 'omnichannel-oncalls',
  OMNICHANNEL_OPERATOR_ACTIVITIES: 'omnichannel-operator-activities',
  OMNICHANNEL_OPERATOR_PARTICIPANTS: 'omnichannel-operator-participants',
  OMNICHANNEL_OPERATOR_PROFILES: 'omnichannel-operator-profiles',
  OMNICHANNEL_OPERATOR_QUEUES: 'omnichannel-operator-queues',
  OMNICHANNEL_OPERATORS: 'omnichannel-operators',
  OMNICHANNEL_OPERATOR_SHIFTS: 'omnichannel-operator-shifts',
  OMNICHANNEL_OPERATOR_STAFFS: 'omnichannel-operator-staffs',
  OMNICHANNEL_OPERATOR_SUPERVISIONS: 'omnichannel-operator-supervisions',
  OMNICHANNEL_QUEUES: 'omnichannel-queues',
  OMNICHANNEL_SUPERVISORS: 'omnichannel-supervisors',
  OMNICHANNEL_TASK_CALLS: 'omnichannel-task-calls',
  OMNICHANNEL_TASK_PARTICIPANTS: 'omnichannel-task-participants',
  OMNICHANNEL_TASKS: 'omnichannel-tasks',
  OMNICHANNEL_TASK_SUPERVISIONS: 'omnichannel-task-supervisions',
  OPERATOR_PROFILES: 'operator-profiles', // TODO: Duplicate namespace [6]
  OPERATOR_QUEUES: 'operator-queues',
  OPERATORS: 'operators', // TODO: Duplicate namespace [9]
  OPERATOR_SKILLS: 'operator-skills',
  PHONE_NUMBERS: 'phone-numbers',
  QUEUES: 'queues',
  QUEUE_SKILLS: 'queue-skills',
  RESOURCE_CATALOG_BUCKETS: 'resource-catalog-buckets',
  RESOURCE_CATALOGS: 'resource-catalogs', // TODO: Duplicate namespace [7]
  SCHEDULES: 'schedules', // TODO: Duplicate namespace [4]
  SHIFTS: 'shifts', // TODO: Duplicate namespace [2]
  SKILLS: 'skills', // TODO: Duplicate namespace [5]
  TASKS: 'tasks',
  WORKFLOWS: 'workflows',
  LISTS: 'lists',
  KEYWORDS: 'keywords',
  ANNOTATIONS: 'training',
  OPERATOR_GROUPS: 'operator-groups'
} as const;

export const ResourcesNameSpaces = {
  BUCKETS: 'buckets',
  BUILDERS: 'builders',
  CMS_BUCKETS: 'cms-buckets',
  DIRECTORIES: 'directories',
  DOCUMENT_BUCKETS: 'document-buckets',
  DOCUMENTS: 'documents',
  DOCUMENT_STATS: 'document-stats',
  FORM_BUCKETS: 'form-buckets',
  FORM_SUBMISSIONS: 'form-submissions',
  LOGS: 'logs',
  OBJECTS: 'objects',
  TEMPLATES: 'templates',
} as const;

export const HelproomsNamespaces = {
  CHANNELS: 'channels', // TODO: Duplicate namespace [8]
  CHANNEL_TYPES: 'channel-types', // TODO: Duplicate namespace [1]
  ENDPOINTS: 'endpoints', // TODO: Duplicate namespace [3]
  HELPROOM_CONVERSATION_REVIEW_MESSAGES: 'helproom-conversation-review-messages',
  HELPROOM_CONVERSATIONS: 'helproom-conversations',
  HELPROOM_DOORS: 'helproom-doors',
  HELPROOM_MASTER_DOORS: 'helproom-master-doors',
  HELPROOMS: 'helprooms',
  HELPROOMS_APPS: 'helprooms_apps',
  HELPROOM_SESSIONS: 'helproom-sessions',
  INGRESS_CONTROLLERS: 'ingress-controllers',
  INGRESS_CONTROLLER_RESOURCES: 'ingress-controller-resources',
  LOGS: 'logs',
  ONE_ON_ONE_CONVERSATIONS: 'one-on-one-conversations',
  ONE_ON_ONE: 'one-on-one',
  OPERATOR_PROFILES: 'operator-profiles', // TODO: Duplicate namespace [6]
  OPERATORS: 'operators', // TODO: Duplicate namespace [9]
  OPERATOR_SHIFTS: 'operator-shifts',
  RESOURCE_CATALOGS: 'resource-catalogs', // TODO: Duplicate namespace [7]
  SCHEDULES: 'schedules', // TODO: Duplicate namespace [4]
  SERVICE_KEYS: 'service-keys',
  SHIFTS: 'shifts', // TODO: Duplicate namespace [2]
  SKILLS: 'skills', // TODO: Duplicate namespace [5]
  STAFF_CONVERSATIONS: 'staff-conversations',
  VISITORS: 'visitors',
} as const;

export const WorkspacesNamespaces = {
  ACCOUNTS: 'accounts',
  ACCOUNTS_PASSWORD: 'accounts-password',
  BUG_REPORTS: 'bug-reports',
  CLIENTS: 'clients',
  GROUP_MEMBERS: 'group-members',
  GROUPS: 'groups',
  INTERNAL_CONVERSATION: 'internal-conversation',
  INTERNAL_CONVERSATION_CHANNELS: 'internal-conversation-channels',
  INTERNAL_CONVERSATION_USERS: 'internal-conversation-users',
  INTERNAL_ONCALLS: 'internal-oncalls',
  LOGS: 'logs',
  ORGANIZATIONS: 'organizations',
  PERMISSIONS: 'permissions',
  POLICIES: 'policies',
  REPORTS: 'reports',
  ROLE_BINDINGS: 'role-bindings',
  ROLES: 'roles',
  TAGS: 'tags',
  WORKSPACE_INGRESS: 'workspace-ingress',
  WORKSPACE_MEMBERS: 'workspace-members',
  WORKSPACES: 'workspaces',
  WORKSPACE_SERVICES: 'workspace-services',
  ADMIN_LINES: 'admin-lines',
  ADMIN_LINES_LOGS: 'admin-lines-logs',
} as const;

export const RHSPermissions = {
  CREATE: 'create',
  GET: 'get',
  LIST: 'list',
  REMOVE: 'remove',
  UPDATE: 'update',
} as const;

export const ShiftNames = {
  OMNICHANNEL_SHIFT: 'OmniChannelShift',
  HELPROOM_SHIFT: 'HelproomShift',
  USER: 'User',
} as const;
// todo userPermisiion

export const UserPermission = {
  QUICKLINK: 'quicklink',
  ONCALL: 'oncall',
  EXTERNAL_CALL: 'external_call',
  INTERNAL_ONCALL_HANDLE: 'internal_oncall_handle',
  INTERNAL_ONCALL_TOKEN: 'internal_oncall_token',
  DASHBOARD_CONTENT_GET: 'dashboard_content_get',
  DASHBOARD_DOCUMENT_LIST: 'dashboard_document_list',
} as const;

export const OmniChannelShiftPermissions = {
  GROUP_CHAT: 'group_chat',
  QUEUE_MUTE_NOTIFICATION: 'queue_mute_notification',
  QUEUE_PICKUP_TASK: 'queue_pickup_task',
  QUEUE_PUSH_REGISTRATION: 'queue_push_registration',
  SUPERVISE: 'supervise',
  SUPPORT_CENTRE: 'support_centre',
  SUPPORT_CENTRE_STAFF: 'support_centre_staff',
  SUPPORT_CENTRE_STAFF_ADD_SUPERVISION: 'support_centre_staff_add_supervision',
  SUPPORT_CENTRE_STAFF_HANDLE_TASK: 'support_centre_staff_handle_task',
  SUPPORT_CENTRE_SUPERVISION: 'support_centre_supervision',
  SWOOP_IN: 'swoop_in',
  TRANSFER_TASK: 'transfer_task',
  WARM_HANDOFF: 'warm_handoff',
  PARTICIPANT_REQUEST: 'participant_request',
  OPERATOR_PROFILE: 'operator_profile',
  QUEUE_LIST: 'queue_list',
} as const;

export const HelproomShiftPermissions = {
  APPROVE_MESSAGE: 'approve_message',
  CHAT: 'chat',
  CLEAR_MESSAGES: 'clear_messages',
  CLOSE_HELPROOM_DOOR: 'close_helproom_door',
  EDIT_MESSAGE: 'edit_message',
  KICK_OUT: 'kick_out',
  ONE_ON_ONE_INVITATION: 'one_on_one_invitation',
  REJECT_MESSAGE: 'reject_message',
  SESSION_UPDATE: 'session_update',
} as const;

export const OmniChannelOperatorProfileStatus = {
  AVAILABLE: 'available',
  AWAY: 'away',
  OFFLINE: 'offline',
  // Mid-task status change (Break & Ending Shift): a 5th Twilio Activity, wire value
  // "EndingShift" — lowercased here to match this codebase's existing convention
  // (staffStatus/activity are always compared via .toLowerCase() against these constants).
  ENDING_SHIFT: 'endingshift',
  // System-computed only (set by Operator#updateStates when an operator is at task capacity) —
  // never returned by operator-activities.list, so this never appears as a selectable status
  // dropdown option. Exists here purely so getOperatorStatusDisplay can render it correctly
  // everywhere else (profile card, footer, staff/supervisor lists).
  BUSY: 'busy',
} as const;

// Single source of truth for how a status is displayed anywhere in the app: label text,
// .rhs-badge color class (_badge.scss), and (for the status dropdown) its subtext description.
// Every consumer — footer, staff/supervisor panels, profile card, status dropdown — calls
// getOperatorStatusDisplay(status) once and destructures what it needs; nothing keeps its own
// copy of this data or its own lowercasing/lookup logic.
export interface OperatorStatusDisplay {
  label: string;
  badgeClass: string;
  description?: string;
}

const OPERATOR_STATUS_DISPLAY: Record<string, OperatorStatusDisplay> = {
  [OmniChannelOperatorProfileStatus.AVAILABLE]: {
    label: 'Available',
    badgeClass: 'available',
    description: 'Eligible for new interactions',
  },
  [OmniChannelOperatorProfileStatus.AWAY]: {
    label: 'Break',
    badgeClass: 'away',
    description: 'Current task continues, no new tasks will be routed post current interaction',
  },
  [OmniChannelOperatorProfileStatus.OFFLINE]: {
    label: 'Offline',
    badgeClass: 'offline',
  },
  [OmniChannelOperatorProfileStatus.ENDING_SHIFT]: {
    label: 'Ending shift',
    badgeClass: 'endingshift',
    description: 'Finishing current task, wrapping up soon',
  },
  [OmniChannelOperatorProfileStatus.BUSY]: {
    label: 'Busy',
    badgeClass: 'busy',
  },
};

const DEFAULT_STATUS_DISPLAY: OperatorStatusDisplay = { label: '', badgeClass: 'available' };

// One call, one object. Accepts any casing (raw wire values like "Away"/"EndingShift", or
// already-lowercased) and returns label/badgeClass/description together — callers destructure
// only what they need instead of calling separate functions per field.
export const getOperatorStatusDisplay = (status?: string | null): OperatorStatusDisplay => {
  if (!status) return DEFAULT_STATUS_DISPLAY;
  return OPERATOR_STATUS_DISPLAY[status.toLowerCase()] ?? { ...DEFAULT_STATUS_DISPLAY, label: status };
};
